'use client';

import React from 'react';
import { Button } from '@heroui/react';
import { useTranslations } from '../../../../contexts/translation.context';
import { RevshareOffer } from '../types';

interface ActionsCellProps {
  offer: RevshareOffer;
  onShowContent: (offer: RevshareOffer) => void;
  onStartCampaign: (offer: RevshareOffer) => void;
}

const ActionsCell: React.FC<ActionsCellProps> = ({ offer, onShowContent, onStartCampaign }) => {
  const { t } = useTranslations();

  return (
    <div className="flex flex-col gap-2 w-[8.5rem]">
      <Button
        size="sm"
        color="primary"
        className="bg-partner text-white h-8 rounded-2 px-3 text-xs font-normal w-full"
        onPress={() => onStartCampaign(offer)}
      >
        {t('partner.revshare.offers.actions.startCampaign')}
      </Button>
      <Button
        size="sm"
        className="bg-[#E6F1FE] text-partner h-8 rounded-2 px-3.5 text-xs font-normal w-full"
        onPress={() => onShowContent(offer)}
      >
        {t('partner.revshare.offers.actions.showContact')}
      </Button>
    </div>
  );
};

export default ActionsCell;
